// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2RD4P","signatureBlock":"Footer_signatureBlock__381Wz","signature":"Footer_signature__3HLcY"};